import React, { useEffect } from 'react';
import { PageComponentProps } from 'shared/interface/globalInterface';
import { CaseListingPage } from '../pages';
import { useDispatch, useSelector } from 'react-redux';
import { resetContainerWidth, setContainerWidth } from 'store/layout/actions';
import User from 'auth/User';

type Props = PageComponentProps;

const Index: React.FC<Props> = () => {
  const dispatch = useDispatch();
  const user: User = useSelector((state: any) => state.auth.user);
  const userName = user.name;

  useEffect(() => {
    dispatch(setContainerWidth('lg'));

    return () => {
      dispatch(resetContainerWidth());
    };
  }, [dispatch]);

  return <>{<CaseListingPage userName={userName} />}</>;
};

export default Index;
